


























































import Vue from 'vue';
import { mapMutations, mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';

import shipmentsService from '@/services/ShipmentsService';
import hazmatService from '@/services/HazmatService';
import referenceTypeService from '@/services/ReferenceTypeService';
import miscService from '@/services/MiscService';
import pendingOrderService from '@/services/PendingOrderService';
import mileageService from '@/services/MileageService';

import { GetBolJsonResponse } from '@/models/shipments/addOrEdit/responses/GetBolJsonResponse';
import { PendingOrderDetailsResponse } from '@/models/shipments/addOrEdit/responses/PendingOrderDetailsResponse';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin],
  data() {
    return {
      bol: null,
      blob: null,
      showLoadingScreen: false,
      showCustomDownloadIcon: false,
      hazmatClasses: [],
      referenceTypes: [],
      multiStopOrderIds: '',
      multiStopOrders: [] as PendingOrderDetailsResponse[],
      allDataLoaded: false,
      miles: 0,
    };
  },
  mounted() {
    document.title = this.$route.params.shipmentId;
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations('billOfLading', ['setExtraStops']),
    init() {
      this.startLoading('Loading the rate confirmation report...');

      const hazmatRequest = hazmatService.list().then((x) => {
        this.hazmatClasses = x;
      });

      const referenceTypesRequest = referenceTypeService.list().then((x) => {
        this.referenceTypes = x;
      });

      const bolJsonRequest = shipmentsService
        .bolJson(this.$route.params.shipmentId)
        .then((b: GetBolJsonResponse) => {
          this.bol = b;
          this.multiStopOrderIds = b.multiStopOrderIds;
          this.setExtraStops(b.extraStops);
        });

      Promise.all([hazmatRequest, referenceTypesRequest, bolJsonRequest]).then(
        () => {
          const origZip = this.bol?.stops[0].postalCode;
          const destZip = this.bol?.stops[1].postalCode;
          mileageService.getMiles(origZip, destZip).then((x) => {
            this.miles = x?.miles;

            miscService.runWithDelay(() => {
              this.initPdfRendering();
            }, 200);
          });
        }
      );
    },
    initPdfRendering() {
      if (!this.isMultiStopShipment) {
        this.stopLoadingAndRenderBol();
      } else {
        this.showMultiStopLoadingMessages();
        this.loadOrders();
      }
    },
    showMultiStopLoadingMessages() {
      this.stopLoading();
      if (!this.allDataLoaded) {
        this.startLoading('Preparing Master Rate Confirmation Report...');
      }

      miscService.runWithDelay(() => {
        this.stopLoading();
        if (!this.allDataLoaded) {
          this.startLoading('Loading shipment stops...');
        }
      }, 3000);
    },
    loadOrders() {
      let requests = [];
      this.multiStopOrderIdsComputed.forEach((x: Number) => {
        const request = pendingOrderService
          .getDetailsById(x)
          .then((o: PendingOrderDetailsResponse) => {
            this.multiStopOrders.push(o);
          });
        requests.push(request);
      });

      Promise.all(requests).then(() => {
        this.allDataLoaded = true;
        miscService.runWithDelay(this.stopLoadingAndRenderBol, 200);
      });
    },
    stopLoadingAndRenderBol() {
      this.$refs.html2Pdf.generatePdf();
      this.stopLoading();
    },
    startLoading(message) {
      this.showLoadingScreen = true;
      this.loadingScreenMessage = message;
    },
    stopLoading() {
      this.showLoadingScreen = false;
      this.loadingScreenMessage = null;
    },
    /* istanbul ignore next */
    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.blob = await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .output('blob')
        .then((data: Blob) => {
          return data;
        });
    },
    /* istanbul ignore next */
    downloadFile() {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(this.blob);
      link.download = this.fileName;
      document.body.append(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    },
    /* istanbul ignore next */
    hasDownloaded() {
      setTimeout(() => {
        this.showCustomDownloadIcon = true;
      }, 500);
    },
  },
  computed: {
    ...mapGetters('billOfLading', ['hasExtraStops']),
    fileName() {
      return this.$route.params.shipmentId;
    },
    bolJson() {
      return this.bol;
    },
    hazmatClassesJson() {
      return this.hazmatClasses;
    },
    referenceTypesJson() {
      return this.referenceTypes;
    },
    multiStopOrderIdsComputed() {
      if (!this.multiStopOrderIds) return [];

      let orderIds = [];
      this.multiStopOrderIds.split(',').forEach((x) => {
        let id = x.trim();
        if (id) {
          orderIds.push(Number(id));
        }
      });
      return orderIds;
    },
    multiStopOrdersComputed() {
      return this.multiStopOrders;
    },
    showLoadingScreenComputed() {
      return this.showLoadingScreen;
    },
    isMultiStopShipment() {
      return this.multiStopOrderIdsComputed.length || this.hasExtraStops;
    },
  },
});
